module.exports = __webpack_public_path__ + "img/AT0000001221223.a1aa45d1.png";